import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

const KNOWLEDGE_BASE_URL =
    import.meta.env.VITE_KNOWLEDGE_BASE_URL || 'https://netfiscus.com/knowledge';

type KnowledgePage =
    | 'import-export'
    | 'mwrr'
    | 'pnl'
    | 'sdr'
    | 'value'
    | 'confirmation'
    | 'ai-assistants';

interface KnowledgeLinkProps {
    page: KnowledgePage;
    /** Fragment appended after the page slug, without the hash. */
    anchor?: string;
    children: React.ReactNode;
    className?: string;
}

export function KnowledgeLink({ page, anchor, children, className }: KnowledgeLinkProps) {
    const href = anchor
        ? `${KNOWLEDGE_BASE_URL}/${page}/#${anchor}`
        : `${KNOWLEDGE_BASE_URL}/${page}/`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={
                className || 'text-accent hover:underline inline-flex items-center gap-1'
            }
        >
            {children}
            <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" aria-hidden="true" />
        </a>
    );
}
